import {Injectable} from '@angular/core';
import {ToastyService} from 'ng2-toasty';
import Swal, {SweetAlertIcon, SweetAlertOptions, SweetAlertPosition, SweetAlertResult} from 'sweetalert2';

@Injectable({
   providedIn: 'root'
})
export class UserNotificationService {
   constructor(
     private toastyService: ToastyService
   ) {
   }
   
   public notificationMessage(sType: string, sMsg: string, sTitle: string, bShowClose: boolean, iTimeoOut?: number) {
      if (iTimeoOut == 0) {
         iTimeoOut = 5000;
      }
      
      switch (sType) {
         case 's': {
            this.toastyService.success({
               msg: sMsg,
               title: sTitle,
               showClose: bShowClose,
               timeout: iTimeoOut,
               theme: 'material',
            });
            
            break;
         }
         
         case 'i': {
            this.toastyService.info({
               msg: sMsg,
               title: sTitle,
               showClose: bShowClose,
               timeout: iTimeoOut,
               theme: 'material',
            });
            
            break;
         }
         
         case 'w': {
            this.toastyService.warning({
               msg: sMsg,
               title: sTitle,
               showClose: bShowClose,
               timeout: iTimeoOut,
               theme: 'material',
            });
            
            break;
         }
         
         case 'e': {
            this.toastyService.error({
               msg: sMsg,
               title: sTitle,
               showClose: bShowClose,
               timeout: iTimeoOut,
               theme: 'material',
            });
            
            break;
         }
         
         case 'pw': {
            this.toastyService.wait({
               msg: sMsg,
               title: sTitle,
               showClose: bShowClose,
               timeout: iTimeoOut,
               theme: 'material',
            });
            
            break;
         }
         
         default: {
            this.toastyService.default({
               msg: 'Bagó',
               title: 'Mensaje no configurado.',
               showClose: true,
               timeout: iTimeoOut,
               theme: 'material',
            });
            
            break;
         }
      }
   }
   
   public notificationMixinInfo(eIconType: SweetAlertIcon, sTitle: string, sText: string, iInterval: number, oSweetAlertPosition: SweetAlertPosition, bShowConfirmButton: boolean, bTimerProgressBar: boolean) {
      const Toast = Swal.mixin({
         toast: true,
         position: oSweetAlertPosition,
         showConfirmButton: bShowConfirmButton,
         timer: iInterval,
         timerProgressBar: bTimerProgressBar,
         // onOpen: (toast) => {
         //    toast.addEventListener('mouseenter', Swal.stopTimer);
         //    toast.addEventListener('mouseleave', Swal.resumeTimer);
         // }
      });
      
      Toast.fire({
         title: sTitle,
         text: sText,
         icon: eIconType
      });
   }
   
   public modalInfo(eIconType: SweetAlertIcon, sTitle: string, sText: string) {
      Swal.fire({
         title: sTitle,
         text: sText,
         icon: eIconType,
         confirmButtonColor: '#9e007e'
      });
   }
   
   public async modalInfoAsync(eIconType: SweetAlertIcon, sTitle: string, sText: string) {
      return await Swal.fire({
         title: sTitle,
         text: sText,
         icon: eIconType,
         confirmButtonColor: '#9e007e'
      }).then((result: any) => {
         return result;
      });
   }
   
   public modalInfoWithOptions(eIconType: SweetAlertIcon, oOptions: SweetAlertOptions) {
      Swal.fire({
         icon: eIconType,
         confirmButtonColor: '#9e007e',
         ...oOptions
      });
   }
   
   public modalInfoHtml(eIconType: SweetAlertIcon, sTitle: string, oText: HTMLSpanElement) {
      Swal.fire({
         title: sTitle,
         html: oText,
         icon: eIconType,
         confirmButtonColor: '#9e007e'
      });
   }
   
   public async modalInfoHtmlAsync(eIconType: SweetAlertIcon, sTitle: string, oText: HTMLSpanElement) {
      return await Swal.fire({
         title: sTitle,
         html: oText,
         icon: eIconType,
         confirmButtonColor: '#9e007e'
      });
   }
   
   public modalInfoHtmlWithOptions(eIconType: SweetAlertIcon, oOptions: SweetAlertOptions, oText: HTMLSpanElement) {
      Swal.fire({
         html: oText,
         icon: eIconType,
         confirmButtonColor: '#9e007e',
         ...oOptions
      });
   }
   
   public async modalInfoHtmlWithOptionsValidation(eIconType: SweetAlertIcon, oOptions: SweetAlertOptions, msgValidation: string, oText?: HTMLSpanElement) {
      let bResult = await Swal.fire({
         html: oText,
         icon: eIconType,
         confirmButtonColor: '#9e007e',
         ...oOptions,
         inputValidator: (value) => {
            if (!value) {
               return msgValidation;
            }
         }
      });
      
      return bResult;
   }
   
   public async modalConfirmsSwal(eIconType: SweetAlertIcon, sTitle: string, sText: string) {
      let bResult: boolean = <boolean>await Swal.fire({
         title: sTitle,
         text: sText,
         icon: eIconType,
         showCancelButton: true,
         confirmButtonColor: '#9e007e',
         cancelButtonColor: '#ffba57',
         confirmButtonText: 'Sí, continuar',
         cancelButtonText: 'Cancelar',
         focusConfirm: true
      }).then((result: SweetAlertResult) => {
         if (result.value) {
            return true;
         } else {
            return false;
         }
      });
      
      return bResult;
   }
   
   public async modalConfirmsSwalWithOptions(eIconType: SweetAlertIcon, oOptions: SweetAlertOptions) {
      let bResult: boolean = <boolean>await Swal.fire({
         icon: eIconType,
         showCancelButton: true,
         confirmButtonColor: '#9e007e',
         cancelButtonColor: '#ffba57',
         confirmButtonText: 'Sí, continuar',
         cancelButtonText: 'Cancelar',
         focusConfirm: true,
         ...oOptions
      }).then((result: SweetAlertResult) => {
         if (result.value) {
            return true;
         } else {
            return false;
         }
      });
      
      return bResult;
   }
}
